import request from '@/utils/request'

const getSalesForceListByConuntry = () => {
  return request({
    path: `/v1/merchants/salesforce/list-by-country`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const createPromotion = (data) => {
  return request({
    path: `/v1/promotions`,
    method: 'POST',
    data,
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const updatePromotion = (promotionId, data) => {
  return request({
    path: `/v1/promotions/${promotionId}`,
    method: 'PUT',
    data,
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const deletePromotion = (promotionId) => {
  return request({
    path: `/v1/promotions/${promotionId}`,
    method: 'DELETE',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const terminatePromotion = (promotionId) => {
  return request({
    path: `/v1/promotions/${promotionId}/terminate`,
    method: 'PATCH',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const uploadPromotionImage = (promotionId, data) => {
  return request({
    path: `/v1/promotions/${promotionId}/images`,
    method: 'POST',
    data,
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotions = ({
  statusGroup = '',
  status = '',
  page = 1,
  pageSize = 10,
}) => {
  return request({
    path: '/v1/promotions',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      page,
      pageSize,
      status_groups: statusGroup !== '0' ? statusGroup : undefined,
      include_stats: true,
    },
  })
}

const getFarahPromotionsReport = ({ startDate, endDate, country }) => {
  return request({
    path: '/v1/promotions/reports',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
      country,
    },
  })
}

const getPromotionCategory = () => {
  return request({
    path: '/v1/promotions/category',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionDetail = (promotionId) => {
  return request({
    path: `/v1/promotions/${promotionId}`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionStats = ({ promotionId, startDate, endDate }) => {
  return request({
    path: `v1/promotions/${promotionId}/reports`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
    },
  })
}

const getOrderStats = ({ promotionId, startDate, endDate, segmentId }) => {
  return request({
    path: `/v1/promotions/${promotionId}/order-stats`,
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
      segment_id: segmentId,
    },
  })
}

const getPromotionOnboardingStatus = () => {
  return request({
    path: '/v1/promotions/onboarding-status',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const merchantPromotionOnboard = () => {
  return request({
    path: '/v1/promotions/onboard',
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionInsights = ({ promotionId, startDate, endDate }) => {
  return request({
    path: `/v1/promotions/${promotionId}/insights`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
    },
  })
}

const getPromotionMonthlyUsage = ({ country, page, pageSize }) => {
  return request({
    path: `/v1/promotions/monthly-usage`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      country,
      page,
      pageSize,
    },
  })
}

const getPromotionMonthlyUsageDetail = (promotionId) => {
  return request({
    path: `/v1/promotions/monthly-usage/${promotionId}`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPromotionMonthUsage = (currency, monthOfYear) => {
  return request({
    path: `/v1/promotions/month-usage`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      currency,
      month_of_year: monthOfYear,
    },
  })
}

export {
  getSalesForceListByConuntry,
  uploadPromotionImage,
  createPromotion,
  updatePromotion,
  deletePromotion,
  terminatePromotion,
  getPromotions,
  getPromotionCategory,
  getPromotionDetail,
  getFarahPromotionsReport,
  getPromotionStats,
  getOrderStats,
  getPromotionOnboardingStatus,
  merchantPromotionOnboard,
  getPromotionInsights,
  getPromotionMonthlyUsage,
  getPromotionMonthlyUsageDetail,
  getPromotionMonthUsage,
}
